import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import AutomaatioMob from './AutomaatioMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';



let stopupdates = function () {};

function Automaatio(p)
{
	React.useEffect( () => { if ( window.RECENTLOAD )  window.drawAutomaatio() } );
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;

	if (! window.KAIKKIAUTOMAATIOKUVATLADATTU )
	{
		function loopy()
		{
			if (! window.KAIKKIAUTOMAATIOKUVATLADATTU )
			{
				setTimeout(loopy, 500);
			}
			else
			{
				let empty = [];
				stopupdates(empty);
			}
			pupdate((window.allmedia.automaatio.length) + " images out of " + window.allmedia.automaatios);
			pupdateLp(100 * (window.allmedia.automaatio.length/window.allmedia.automaatios));
		}
		setTimeout(loopy, 1000);
		return(	<ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />{nomoreload}
				</div>
			</div></ThemeProvider>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<AutomaatioMob />);
		}
		else
		{

			return (<div style={{color: "#000000", fontSize: "125%"}}>
			<div key="automaatioosioeka" className="kuvallinenoikea">
				<div>
					<img height="500vh" src={window.AUTOMAATIOTEKSTIT.ekaosiokuva} />
				</div>
				<div>
					<h1>{window.AUTOMAATIOTEKSTIT.ekaosio}</h1>
					<div key="gapihmomia" className="otsikkogap"></div>
					{window.AUTOMAATIOTEKSTIT.ekaosioekar}
					<div key="gapihmomib" className="paragap"></div>
					{window.AUTOMAATIOTEKSTIT.ekaosiotokar}
				</div>
			</div>
			<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
			<div key="gapihmomic" className="osiogap"></div>
			<div key="automaatioosiotoka" className="kuvallinenvasenkapea">
				<div style={{width: "80%", display: "flex", alignItems: "center"}}>
					<span style={{verticalAlign: "middle"}} >{window.AUTOMAATIOTEKSTIT.tokaosioekar}</span>
				</div>
				<div>
					<img height="250vh" src={window.AUTOMAATIOTEKSTIT.tokaosiokuva} />
				</div>
			</div>
			<div key="gapihmomid" className="osiogap"></div>

			<div className="vasenlevea">
				<h3>{window.AUTOMAATIOTEKSTIT.kolmasosio}</h3>
			</div>
			<div key="gapihmomie" className="osiogap"></div>
			<BlobRight fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" />
			<div key="automaationeljasosio" className="kuvallinenoikeavasmargi">
				<div>
					<img height="300vh" src={window.AUTOMAATIOTEKSTIT.kolmasosiokuva} />
				</div>
				<div></div>
				<div>
					{window.AUTOMAATIOTEKSTIT.kolmassosioekar}
					<div key="gapihmomif" className="paragap"></div>
					<h3>{window.AUTOMAATIOTEKSTIT.kolmasosiotokar}</h3>
				</div>
			</div>
			<div key="gapihmomig" className="osiogap"></div>
			<div key="gapihmomigla" className="osiogap"></div>
			<div key="gapihmomiglb" className="osiogap"></div>

			<div className="seuraavasivu">
				<div className="seuraavasivuotsikko" >
					<Link to="../luonti" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToLuonti}>
						<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>KUVIEN LUONTI</span>
					</Link>
				</div>
				<div style={{transform: "scale(0.75)"}}>
					<Link to="../luonti" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToLuonti}>
						<ArrowRight stroke="#000000"/>
					</Link>
				</div>
			</div>


			</div>);
		}
	}
}

function moveToLuonti()
{
	window.SETLUONTI();
	window.drawLuonti();
}

export default Automaatio;
